import React from 'react'
import { Form } from 'react-bootstrap'
import UploadFile from './UploadFile'
import DeleteBtn from '../../../buttons/DeleteBtn'
import { swalAlertError, swalAlertIsConfirm, swalLoading, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import Swal from 'sweetalert2'
import { articlesApi } from '../../../../api/articlesApi'

const ProductImagegesAndVideo = ({
  inputs,
  handleChange,
  uploadCoverImage,
  uploadImages,
  reload,
  setReload,
  refreshProductInfo,
}) => {

  const removeDocument = async (img, isImagenPortada) => {
    try {
      console.log(img, isImagenPortada)
      const alert = await swalAlertIsConfirm(
        `¿Seguro que quieres eliminar la imagen ${img} del producto?`,
      )
      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        const response = await articlesApi?.deleteArticlesDocumentsByName(
          { id: inputs?.id_Articulo, isImagenPortada: isImagenPortada, name: img }
        )
        Swal.close()
        swalSuccessGeneral(swalTitle.Eliminado, response.data)
        setReload((prev) => !prev)

        if (isImagenPortada === 1) {
          handleChange({ target: { name: 'cover', value: '' } })
          handleChange({
            target: {
              name: 'coverCount',
              value: Math.max(0, Number(inputs?.coverCount || 0) - 1),
            },
          })
        } else {
          const updatedImages = inputs.images.filter((image) => image !== img)
          handleChange({ target: { name: 'images', value: updatedImages } })
          handleChange({
            target: {
              name: 'imageCount',
              value: updatedImages.length,
            },
          })
        }

        if (typeof refreshProductInfo === 'function') {
          await refreshProductInfo()
        }
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)

    }
  }

  const MiniRemoveButton = ({ img, isImagenPortada }) => {
    return (<button style={{ marginLeft: "1rem", color: 'red', fontWeight: 'bold' }} onClick={(e) => removeDocument(img, isImagenPortada)}>
      <DeleteBtn size={14} />
    </button>
    )
  }

  return (
    <div className='images-video-container' style={{ alignItems: 'flex-start' }}>
      <div className='images-video-field'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>Vídeo</Form.Label>
          <Form.Control
            className='user-input form__input'
            type='text'
            name='link'
            value={inputs.link}
            onChange={handleChange}
            placeholder='Link del vídeo'
          />
        </Form.Group>
      </div>

      <div className='images-video-field'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Imagen de portada
            <span style={{ color: 'gray' }}> ({inputs.coverCount}) </span>
          </Form.Label>
          <UploadFile
            style={{ margin: '0px' }}
            uploadFile={uploadCoverImage}
            reload={reload}
            typeUpload={'.jpg, .jpeg, .png'}
          />
        </Form.Group>

        <ul className="product-file-list">
          {inputs?.cover &&
            <li>{inputs?.cover} <MiniRemoveButton img={inputs?.cover} isImagenPortada={1} /></li>
          }
        </ul>
          
      </div>

      <div className='images-video-field'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Imágenes del producto
            <span style={{ color: 'gray' }}> ({inputs.imageCount}) </span>
          </Form.Label>
          <UploadFile
            uploadFile={uploadImages}
            multiple={'multiple'}
            reload={reload}
            typeUpload={'.jpg, .jpeg, .png'}
          />
        </Form.Group>
        
        <ul className="product-file-list">
          {Array.isArray(inputs?.images)
            && inputs.images.map((img, idx) => <li key={idx}>{img} <MiniRemoveButton img={img} isImagenPortada={-1} /></li>)
          }
        </ul>
      </div>
    </div>
  )
}

export default ProductImagegesAndVideo
